import { render, staticRenderFns } from "./accRecord.vue?vue&type=template&id=0637f150&"
import script from "./accRecord.vue?vue&type=script&lang=js&"
export * from "./accRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports